module.exports = __webpack_public_path__ + "img/CM-DJ-26-Nissan-Lifestyle.5919c137.jpg";